<template>
  <div id="AddSemesterDialog" class="wrap">
   
      <v-icon slot="activator" @click.stop="showEditCourse" small color="grey">edit</v-icon>
    
    <v-dialog
        v-model="EditCourseDialog"
      >
         <v-card tile>
          <v-toolbar card dark color="blue">
            <v-icon>edit</v-icon>
            <v-toolbar-title>{{course.course_name}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right offset-y>


            </v-menu>
          </v-toolbar>
          <v-card-text>

          <v-container grid-list-md>
            <v-layout wrap>
              <!-- Select Semester -->
              <v-flex xs12>
                <v-autocomplete
                  v-model="course.semesterId"
                  :items="college.semesters"
                  hide-selected
                  item-text="semester_term"
                  item-value="id"
                  label="Select Semester"
                  disabled
                  >
                  <!-- Semester Input  -->
                  <template
                    slot="selection"
                    slot-scope="data"
                    >
                     <span v-html="data.item.semester_academic_status"> </span>
                    <span class="ml-2 caption grey--text" v-html="data.item.semester_term"></span>
                    <span class="ml-2 caption grey--text">{{data.item.semester_year | moment("YYYY")}}</span>

                  </template>
                  <!-- Semester Dropdown -->
                  <template
                    slot="item"
                    slot-scope="data"
                    >

                    
                      <span v-html="data.item.semester_academic_status"> </span>
                      <span  class="ml-2 caption grey--text" v-html="data.item.semester_term"></span>
                      <span  class="ml-1 caption grey--text" >{{data.item.semester_year | moment("YYYY")}}</span>


                  </template>
                </v-autocomplete>
              </v-flex>
              


              <!-- Lab Radio Group -->
              <v-flex xs12 sm6 md4>
                <span class="subheading">Lab:</span>
                <v-radio-group v-model="course.course_lab" row>
                  
                  <v-radio
                    label="with lab"
                    value='true'
                  ></v-radio>
                  <v-radio
                    label="without lab"
                    value=false
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <!-- Semester  Academic Status-->
              <v-flex xs12>
                <v-text-field
                  v-model="course.course_credits"
                  label="Course Credits"
                  required
                ></v-text-field>
              </v-flex>

              <!-- Course Grade-->
              <v-flex xs12 v-if="EditCourseDialog === true">
                <v-autocomplete
                  v-model="course.course_grade"
                  :items="['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C', 'C+', 'C-', 'D+', 'D', 'D-', 'F']"
                  label="Course Grade"

                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>

          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click.native="EditCourseDialog = false">Close</v-btn>
          <v-btn color="blue darken-1" outline flat @click.native="editCourse()">Save</v-btn>
        </v-card-actions>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
  </div>

</template>

<script>
  export default {
    props: ['semester', 'college', 'course'],
     data() {
      return {
        modal: false,
        alert: false,
        menu3: false,
        EditCourseDialog : false,        
      }
    },
    methods: {
      showEditCourse(user) {
        if(user !== null && user !== undefined ){
          this.EditCourseDialog = true
        }
        else {
          this.alert = true
        }
      },
      editCourse () {
        const courseData = {
          course_lab: this.course.course_lab,
          course_credits: this.course.course_credits,
          course_grade: this.course.course_grade,
          courseId: this.course.id,
          semesterId: this.semester.id,
          collegeId: this.college.id,
        }
        this.EditCourseDialog = false
        this.$store.dispatch('setEditCourse', courseData)
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },
      courses() {
        return this.$store.getters.loadedCourses
      }
    },
  }
</script>

<style scoped>
.wrap {
    margin-top: 8vh !important;
    
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Courses/EditCourseDialog.vue